module.exports = __webpack_public_path__ + "img/opioid_bottom_picture.372b2562.png";